import { useCallback } from 'react'

import { useQuoteData } from '@flows-ui/services/QuoteDataContext'
import type { PriceChangeUserAction } from '@flows-ui/services/QuoteDataContext.types'

export const usePriceChangeTracking = () => {
  const { trackPriceChange } = useQuoteData()

  return {
    trackPriceChange: useCallback(
      (action: PriceChangeUserAction) => {
        trackPriceChange(action)
      },
      [trackPriceChange]
    ),
  }
}
